import React from 'react';
import { Box } from '@material-ui/core';
import { ErrorMessage, getIn } from 'formik';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Dropdown from '../Dropdown';
import HelperText from '../HelperText';
import styles from './ValidatedDropdown.module.css';

const ValidatedDropdown = ({ field, form, label, error, type, ...props }) => {
    const { errors, touched } = form;

    const isTouched = getIn(touched, field.name);
    const errorText = getIn(errors, field.name);

    return (
        <Box className={cn(styles.group, props.className)}>
            {label && <label className={styles.label}>{label}</label>}
            <Dropdown {...field} {...props} isInvalid={isTouched && errorText} />
            <ErrorMessage name={field.name} component={HelperText} />
        </Box>
    );
};

ValidatedDropdown.propTypes = {
    field: PropTypes.object,
    form: PropTypes.object,
    label: PropTypes.string,
    error: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string,
};

export default ValidatedDropdown;
